import { render, staticRenderFns } from "./jsfList.vue?vue&type=template&id=2258f772&scoped=true&"
import script from "./jsfList.vue?vue&type=script&lang=js&"
export * from "./jsfList.vue?vue&type=script&lang=js&"
import style0 from "./jsfList.vue?vue&type=style&index=0&id=2258f772&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2258f772",
  null
  
)

export default component.exports